// export const GOOGLE_KEY = process.env.NODE_ENV === 'development' ?
//   '' : 'AIzaSyD9Vws7N_uC2Zd6znhSd83AKgLXn_kN5zU';

export const GOOGLE_KEY = 'AIzaSyD9Vws7N_uC2Zd6znhSd83AKgLXn_kN5zU';
